/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Footer } from 'src/components/Footer/Footer';
import { GraphQLRequest } from 'src/helpers/GraphQLRequest';
import { Store } from 'src/types';
import { VALIDATE_POLICY_QUERY } from '../../configs/APISchemas/ValidatePolicyGraphQL';
import CoverageVerified from '../CoverageVerified/CoverageVerified';
import NoPolicyLocated from '../NoPolicyLocated/NoPolicyLocated';
import { ScrollToTop } from 'src/components';
import { Box } from '@mui/material';
import { LogoAnimationLoader } from 'src/components/LogoLoader/LogoAnimationLoader';
import UploadSuccess from 'src/components/Covie/components/UploadSuccess';


const Compliance = () => {
  const [status, setStatus] = useState<string>('');
  const params: any = useParams();
  const quote = useSelector((store: Store) => store.general.quote);
  useEffect(() => {
    validatePolicy();
  }, []);

  const validatePolicy = async () => {
    const firstName = quote.given_name.trim();
    const lastName = quote.family_name.trim();
    const name = `${firstName} ${lastName}`;
    try {
      const mutation = VALIDATE_POLICY_QUERY(
        params.covie_id,
        name,
        firstName,
        lastName,
        quote.email,
        {
          street: quote.address.street,
          addressNumber: quote.address.addressNumber,
          postalCode: quote.address.postalCode,
          municipality: quote.address.municipality,
          region: quote.address.state,
        },
        quote.buildingUnit,
        quote.start_date,
        quote.end_date,
        quote.buildingId
      );
      const response = await GraphQLRequest(mutation);
      if (response.validateCoviePolicy) {
        if (response.validateCoviePolicy.errors) {
          if (
            response.validateCoviePolicy.errors[0].type ===
            'APPLICATION_ALREADY_COMPLIANT'
          ) {
            setStatus('compliant');
            return;
          }
          if (response.validateCoviePolicy.errors[0].type === 'Error') {
            setStatus('serverError');
            return;
          } else if (response.validateCoviePolicy.errors[0].type) {
            setStatus('uncomplied');
          } else {
            setStatus('serverError');
          }
          return;
        } else if (response.validateCoviePolicy.validation?.errors) {
          if (
            response.validateCoviePolicy.validation?.errors[0].type === 'Error'
          ) {
            setStatus('serverError');
            return;
          }
          setStatus('uncomplied');
          return;
        } else if (response.validateCoviePolicy.application?.id) {
          setStatus(response.validateCoviePolicy.application.status);
        }
        //success here
        return;
      }
      setStatus('serverError');
      return;
    } catch (error: any) {
      if (error.response?.data?.errors) {
        setStatus('uncomplied');
      } else {
        setStatus('serverError');
      }
    }
  };

  if (status === 'compliant') {
    return (
      <>
        <CoverageVerified />
        <Footer withMarginTop={true} withBackgroundColor={false}/>
      </>
    );
  }

  if (status === 'uncomplied') {
    return (
      <>
        <UploadSuccess />
        <Footer withMarginTop={true} withBackgroundColor={false}/>
      </>
    );
  }
  if (status === 'serverError') {
    return (
      <>
        <NoPolicyLocated />
        <Footer withMarginTop={true} withBackgroundColor={false}/>
      </>
    );
  }

  return (

  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="80vh"
  >
    <ScrollToTop />
    <LogoAnimationLoader/>
  </Box>

  );
};
export default Compliance;
